import { connect } from 'react-redux'
import get from 'lodash/get'

import {
  changeReport as onСhangeReport,
  clearReport as onClearReport
} from '../../actions/reportActions'

const mapStateToProps = (state) => ({
  reportTitle: get(state, ['report', 'title'], ''),
  reportId: get(state, ['report', 'id'], ''),
  reportType: get(state, ['report', 'type'], null)
})

const mapDispatchToProps = {
  onСhangeReport,
  onClearReport
}

const withReport = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withReport }